import React from 'react';
import PropTypes from 'prop-types';
import ButtonPrimary from '../ButtonPrimary';
import './styles.scss';

const ButtonPrimaryCrudFooter = ({ classNames = [], ...props }) => (
    <ButtonPrimary {...props} classNames={['custom-btn-primary-crud-footer', ...classNames]} />
);

ButtonPrimaryCrudFooter.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonPrimaryCrudFooter;
